<template>
  <b-modal
    :title="`Enviar Expediente ${file.numero}`"
    v-model="showModal"
    hide-footer
    centered
  >
    <div>
      <h5>
        Para:
      </h5>
      <div class="wrap-option">
        <vs-radio v-model="subject.typeSend" vs-value="moodUser">Usuario</vs-radio>
        <vs-radio v-model="subject.typeSend" vs-value="moodGroup">Unidad</vs-radio>
      </div>
      <div
        v-if="subject.typeSend === 'moodUser' && usersCompany && usersCompany.length"
        class="wrap-form"
      >
        <list-user
          class="w-100"
          name="user"
          :block="false"
          label="Usuarios"
          v-model="subject.user"
        />
      </div>
      <div v-if="isAguasAndinas && subject.typeSend === 'moodUser'">
        <div class="row">
          <div class="col-12 text-danger my-2">
            El destinatario responsable actual tiene la providencia
            <span>{{providenceSubject}}</span>
            <span v-if="providence.providenciaVencimiento">
              con fecha de vencimiento {{providence.providenciaVencimiento | dateFormat}}
            </span>
          </div>
          <div class="col-12" v-if="providenceSubject === 'gestión'">
            <label>Fecha Vencimiento</label>
            <b-form-datepicker
              :min="minDate"
              :max="maxDate"
              :show-decade-nav="false"
              :hide-header="false"
              placeholder="Fecha vencimiento"
              name="providenceExpiration"
              data-vv-as="fecha vencimiento"
              label-help="Puede usar las flechas del teclado y espacio"
              v-model="providenceDate"
              data-cy="calendar"
            />
          </div>
        </div>
      </div>
      <div
        v-if="subject.typeSend === 'moodGroup' && groupsCompany && groupsCompany.length"
        class="wrap-form"
      >
        <list-groups
          class="w-100"
          name="group"
          :block="false"
          label="Unidad"
          v-model="subject.group"
        />
      </div>
      <div class="wrap-commentary">
        <vs-textarea
          data-cy="comment"
          maxlength="255"
          label="Comentario"
          v-model="subject.commentary"
        />
      </div>
    </div>
    <div>
      <vs-collapse>
        <vs-collapse-item>
          <div slot="header">
            <h5>
              Con copia:
            </h5>
          </div>
          <div>
            <div class="wrap-option">
              <vs-radio v-model="copy.typeCopy" vs-value="sendUser">Usuario</vs-radio>
              <vs-radio v-model="copy.typeCopy" vs-value="sendGroup">Unidad</vs-radio>
            </div>
            <div
              v-if="copy.typeCopy === 'sendUser' && usersCompany && usersCompany.length"
              class="wrap-form">
              <list-user
                class="w-100"
                name="user"
                :block="false"
                label="Usuarios"
                v-model="copy.user"
              />
            </div>
            <div
              v-if="copy.typeCopy === 'sendGroup' && groupsCompany && groupsCompany.length"
              class="wrap-form"
            >
              <list-groups
                class="w-100"
                name="group"
                :block="false"
                label="Unidad"
                v-model="copy.group"
              />
            </div>
            <div class="m-top-20">
              <vs-textarea
                maxlength="255"
                label="Comentario"
                v-model="copy.commentary"
              />
            </div>
          </div>
        </vs-collapse-item>
      </vs-collapse>
    </div>
    <div class="m-top-20 text-center">
      <vs-button
        data-cy="send"
        v-on:click="sendFileToSubjects()"
        color="primary"
        type="border"
      >
        Enviar Expediente
      </vs-button>
    </div>
  </b-modal>
</template>
<script>

import { mapActions, mapGetters } from 'vuex';

import ListUser from '@/febos/chile/lists/components/ListUser';
import ListGroups from '@/febos/chile/lists/components/ListGroups';
import { AGUAS_ANDINAS } from '@/constants/companies';
import ProvidencesTypes from '@/febos/chile/dnt/mixins/ProvidencesTypes';

export default {
  components: { ListUser, ListGroups },
  name: 'PopUpSendFile',
  props: {
    file: {
      type: [Object]
    }
  },
  data() {
    return {
      providenceTypes: ProvidencesTypes,
      providence: {},
      locale: 'es',
      providenceDate: '',
      minDate: this.$moment().format('YYYY-MM-DD'),
      maxDate: '',
      subject: {
        typeSend: 'moodUser',
        group: '',
        user: '',
        commentary: ''
      },
      copy: {
        typeCopy: 'sendGroup',
        group: '',
        user: '',
        commentary: ''
      },
    };
  },
  watch: {
    file() {
      const { destinatarios } = this.file;
      if (destinatarios) {
        // eslint-disable-next-line eqeqeq
        this.providence = destinatarios.find((subject) => subject.tipoDestino == 1);
      }
      this.maxDate = this.$moment(this.file.fechaVencimiento).format('YYYY-MM-DD');
      this.subject = {
        typeSend: 'moodUser',
        group: '',
        user: '',
        commentary: ''
      };
      this.copy = {
        typeCopy: 'sendGroup',
        group: '',
        user: '',
        commentary: ''
      };
    }
  },
  computed: {
    ...mapGetters('Dnts', [
      'commentsEd'
    ]),
    ...mapGetters('Empresas', [
      'empresa',
      'usersCompany',
      'groupsCompany'
    ]),
    ...mapGetters('Modals', [
      'modalName'
    ]),
    providenceSubject() {
      if (this.providence.providenciaId === this.providenceTypes.KNOWLEDGE
        || (this.providence.providenciaId
          && this.providence.providenciaId.toString()
          === this.providenceTypes.KNOWLEDGE.toString())) {
        return 'conocimiento';
      }
      return 'gestión';
    },
    isAguasAndinas() {
      return this.empresa.iut === AGUAS_ANDINAS.iut;
    },
    showModal: {
      get() {
        return this.modalName === 'sendFile';
      },
      set() {
        this.closeModal();
      }
    }
  },
  methods: {
    ...mapActions('Modals', [
      'closeModal'
    ]),
    ...mapActions('Empresas', [
      'getUsersCompany',
      'getGroupsCompany'
    ]),
    ...mapActions('Dnts', [
      'sendDntFile'
    ]),
    convertSubjectUser(data, type) {
      const subject = {
        tipoDestino: type,
        estado: 1,
        destinoCodigo: 'usuarios',
        destinoNombre: 'Funcionario',
        destinoListaCodigo: data.id,
        destinoListaNombre: data.nombre,
        destinoCorreo: '',
        comentario: this.subject.commentary
      };
      if (this.providence.providenciaId && type === 1) {
        subject.providenciaId = this.providence.providenciaId;
        subject.providenciaVencimiento = this.providenceDate
          || this.providence.providenciaVencimiento;
      }
      return subject;
    },
    convertSubjectGroup(data, type) {
      return {
        tipoDestino: type,
        estado: 1,
        destinoCodigo: 'unidades',
        destinoNombre: 'Unidades',
        destinoListaCodigo: data.id,
        destinoListaNombre: data.nombre,
        destinoCorreo: '',
        comentario: this.copy.commentary
      };
    },
    sendFileToSubjects() {
      const newSubjects = [];
      let user;
      let group;
      if (this.subject.user !== '') {
        user = this.usersCompany.find((userCompany) => userCompany.id === this.subject.user);
        newSubjects.push(this.subjectSend = this.convertSubjectUser(user, 1));
      }
      if (this.subject.group !== '') {
        group = this.groupsCompany.find((groupCompany) => groupCompany.id === this.subject.group);
        newSubjects.push(this.subjectSend = this.convertSubjectGroup(group, 1));
      }

      if (this.copy.user !== '') {
        user = this.usersCompany.find((userCompany) => userCompany.id === this.copy.user);
        newSubjects.push(this.copySend = this.convertSubjectUser(user, 2));
      }
      if (this.copy.group !== '') {
        group = this.groupsCompany.find((groupCompany) => groupCompany.id === this.copy.group);
        newSubjects.push(this.copySend = this.convertSubjectGroup(group, 2));
      }

      this.sendDntFile({
        febosId: this.file.febosId,
        destinos: newSubjects
      });
      this.subject = {
        typeSend: 'moodUser',
        group: '',
        user: '',
        commentary: ''
      };
      this.copy = {
        typeCopy: 'sendGroup',
        group: '',
        user: '',
        commentary: ''
      };
    }
  }
};
</script>
<style>

.m-top-20 {
  margin-top: 20px;
}

.wrap-option {
  display: flex;
  justify-content: space-around;
}

.wrap-form {
  display: flex;
  justify-content: space-around;
  margin-top: 20px;
}

.pill-comment-user {
  width: 90%;
  border: 1px solid #c2f785;
  border-radius: 25px;
  margin-bottom: 10px;
  float: left;
}

.pill-comment-me {
  width: 90%;
  border: 1px solid #3a9eef6b;
  border-radius: 25px;
  margin-bottom: 10px;
  float: right;
}

.wrap-commentary {
  width: 90%;
  margin: 20px auto;
}
</style>
